import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ScoreList from './List';

const Scores = {
  icon: QueryStatsIcon,
  name: 'statistiques/scores/:idRestaurant',
  list: ScoreList,
};

export default Scores;